<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useTaskResponsibleTeam } from '../../model/task-responsible-team.hook'
import TaskInfoList from './TaskInfoList.vue'
import TaskInfoItem from './TaskInfoItem.vue'
import TaskResponsibleAssignee from './TaskResponsibleAssignee.vue'

defineOptions({
  name: 'TaskResponsible',
})

const { refTeamLabel } = useTaskResponsibleTeam()
</script>

<template>
  <TaskInfoList>
    <TaskInfoItem title="Team">
      <AppText
        name="body1"
        color="slate-900"
      >
        {{ refTeamLabel || '-' }}
      </AppText>
    </TaskInfoItem>
    <TaskInfoItem title="Assignee">
      <TaskResponsibleAssignee />
    </TaskInfoItem>
  </TaskInfoList>
</template>
